const { onlyNumericNormalize, SPACE } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyNumericNormalize(zipCode);
  if (zipCode.length <= 4) {
    return zip;
  }
  return `${zip.slice(0, 4)} ${zip.slice(4, 8)}`;
};

exports.countryDefinition = {
  country: 'Lebanon',
  code: 'LB',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address', SPACE, 'address2'],
    ['city', SPACE, 'zipCode']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['city', 'zipCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^[0-9]{4}(?:[0-9]{4})?$/),
      error: 'Must be 4 numbers or 4+4 numbers, 2038 or 20383054'
    }
  ]
};
